<!--
 * @Description: 
 * @Date: 2021-08-27 15:11:23
-->
<template>
  <el-date-picker
    v-model="dateValue"
    type="monthrange"
    align="right"
    unlink-panels
    range-separator="-"
    start-placeholder="开始日期"
    end-placeholder="结束日期"
    :picker-options="pickerOptions2"
    :editable="false"
    @change="dateChange"
    value-format="yyyy-MM"
  ></el-date-picker>
</template>

<script>
export default {
  data() {
    return {
      dateValue: '',
      pickerOptions2: {
        disabledDate: this.disableMethod,
        shortcuts: [
          {
            text: '本月',
            onClick(picker) {
              const end = new Date();
              const start = new Date(end.getFullYear(), end.getMonth());
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 2);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近六个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 5);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '今年至今',
            onClick(picker) {
              const end = new Date();
              const start = new Date(new Date().getFullYear(), 0);
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      }
    };
  },
  methods: {
    dateChange() {
      this.$emit('dateChange', this.dateValue);
    },
    disableMethod(time) {
      return (
        time.getTime() - Date.now() > 365 * 24 * 3600 * 1000 ||
        time.getTime() - Date.now() < -365 * 24 * 3600 * 1000
      );
    }
  },
  created() {}
};
</script>
